import Vue from 'vue'
import Router from 'vue-router'
import Example from "./views/Example"
import LookupView from "./views/web/dictionary/lookup/LookupView"
import Main from "./components/homepage/Main"
import WordOxfordView from "./views/extension/dictionary/WordOxfordView"
import Privacy from "./views/privacy/Privacy"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Main
    },
    {
      path: '/lookup',
      name: 'lookupView',
      component: LookupView
    },
    {
      path: '/example',
      name: 'example',
      component: Example
    },
    {
      path: '/privacy.html',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/ext/lookup/oxford',
      name: 'WordOxfordView',
      component: WordOxfordView,
      props: (route) => ({wordText: route.query.word})
    }
  ]
})
